module.exports = __webpack_public_path__ + "img/icon_download.ed4ee5a5.png";